import { render, staticRenderFns } from "./SuperStage.vue?vue&type=template&id=073ff200&"
import script from "./SuperStage.vue?vue&type=script&lang=js&"
export * from "./SuperStage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports